export const loginData = [
  {
    attr: 'Token',
    req: true,
    type: 'text',
    rules: {
      required: { value: true, message: 'Please fill this field' },
      maxLength: { value: 50, message: 'Input too long' },
    },
  },
];
